import { styled } from '@mui/material'
import { MapDisplayButtonContainer } from 'containers/seoPages/SearchContent.style'

interface MapDisplayButtonProps {
  $hideFixedButton: boolean
}

export const StyledMapDisplayButtonContainer = styled(
  MapDisplayButtonContainer
)<MapDisplayButtonProps>`
  opacity: ${({ $hideFixedButton }) => ($hideFixedButton ? 0 : 1)};
  transition: opacity 0.1s ease-in-out;
`

export const SeeMoreButtonContainer = styled(MapDisplayButtonContainer)`
  position: relative;
  align-items: center;
`
